module.exports = __webpack_public_path__ + "img/53.02720e9e.jpg";